'use strict';

const behavior = {};

exports.behavior = behavior;
